<template>
	<div>
		<!-- ################################################ -->
		<!-- People type A -->
		<!-- ################################################ -->
		<div class="fs4 fw7 lh125">
			6. (I) Give the following information in respect of all insured property
			(inclusive of amounts carried to and from Bank or Safe Deposit) carried
			outside the Proposer's Premises stated in Question 1(b) by yourselves,
			your representatives, travelers, agents, messengers and delivery hands but
			NOT Brokers during the last 12 months.
		</div>
		<div class="mt10 fw5 mb2">
			In the City or Town in which the Proposer's premises are situated:
		</div>
		<j-expendable-box
			v-for="i in numberOfPeopleA"
			:key="'peopleA' + i"
			class="mb2"
		>
			<div slot="header" class="xs-12 p4 fs4 fw7 bg5 r2 b1 bc7">
				Person {{ i }}
			</div>
			<div slot="body" class="xs-12 p4 bg5 b1 bt0 bc7 r2">
				<case-form
					:schema="generateSchemaForPersonTypeA(i - 1)"
					:isBoxed="false"
				/>
			</div>
		</j-expendable-box>
		<!-- Messengers -->
		<j-expendable-box class="mb2">
			<div slot="header" class="xs-12 p4 fs4 fw7 bg5 r2 b1 bc7">
				Messengers
			</div>
			<div slot="body" class="xs-12 p4 bg5 b1 bt0 bc7 r2">
				<case-form :schema="generateSchemaForMessengersA()" :isBoxed="false" />
			</div>
		</j-expendable-box>

		<!-- ################################################ -->
		<!-- People type B -->
		<!-- ################################################ -->
		<div class="fs4 fw7 lh125 mt6">
			6. (II) Give the following information of all the banker notes carried
			outside the proposer’s premises in Question 1(b) by yourselves, your
			representatives, travelers, agents, messengers and delivery hands.
		</div>
		<div class="fw5 lh125 mt10 mb2">
			In the city or town in which the Proposers’ Premises are situated
		</div>
		<j-expendable-box
			v-for="i in numberOfPeopleB"
			:key="'peopleB' + i"
			class="mb2"
		>
			<div slot="header" class="xs-12 p2 pt4 pb4 fs4 fw7 bg5 r2 b1 bc7">
				Person {{ i }}
			</div>
			<div slot="body" class="xs-12 p4 bg5 b1 bc7 r2 bt0">
				<case-form
					:schema="generateSchemaForPersonTypeB(i - 1)"
					:isBoxed="false"
				/>
			</div>
		</j-expendable-box>
		<!-- Messengers -->
		<j-expendable-box class="mb2">
			<div slot="header" class="xs-12 p4 fs4 fw7 bg5 r2 b1 bc7">
				Messengers
			</div>
			<div slot="body" class="xs-12 p4 bg5 b1 bt0 bc7 r2">
				<case-form :schema="generateSchemaForMessengersB()" :isBoxed="false" />
			</div>
		</j-expendable-box>
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"
import JExpendableBox from "@/components/JExpendableBox"

export default {
	name: "JBProposalOutdoorRisk",
	components: { CaseForm, JExpendableBox },
	data() {
		return {
			numberOfPeopleA: 3,
			numberOfPeopleB: 3
		}
	},

	methods: {
		generateSchemaForPersonTypeA(index) {
			return [
				{
					label: "Select Principal, Representative, Traveler or Agent",
					component: "entityRelationship",
					entity: "case.holder",
					relation: "case.holder.relationships",
					bindTo: `case.facts.insuredPropertyCarrier${index}RelationshipId`
				},
				{
					label: "Number of days per annum",
					component: "text",
					bindTo: `case.facts.insuredPropertyCarrier${index}NoOfDays`
				},
				{
					label: "Average Amount",
					component: "text",
					bindTo: `case.facts.insuredPropertyCarrier${index}AverageAmount`
				},
				{
					label: "Maximum Amount",
					component: "text",
					bindTo: `case.facts.insuredPropertyCarrier${index}MaxAmount`
				}
			]
		},

		generateSchemaForMessengersA() {
			return [
				{
					label: "Number of messengers and delivery hands",
					component: "text",
					bindTo: "case.facts.insuredPropertyMessenger"
				},
				{
					label: "Number of days each person per annum",
					component: "text",
					bindTo: "case.facts.insuredPropertyMessengerNoOfDays"
				},
				{
					label: "Average Amount each",
					component: "text",
					bindTo: "case.facts.insuredPropertyMessengerAverageAmount"
				},
				{
					label: "Maximum Amount each",
					component: "text",
					bindTo: "case.facts.insuredPropertyMessengerMaxAmount"
				}
			]
		},

		generateSchemaForPersonTypeB(index) {
			return [
				{
					label: "Select Principal, Representative, Traveler or Agent",
					component: "entityRelationship",
					entity: "case.holder",
					relation: "case.holder.relationships",
					bindTo: `case.facts.bankNotesCarrier${index}RelationshipId`
				},
				{
					label: "Number of days per annum",
					component: "text",
					bindTo: `case.facts.bankNotesCarrier${index}NoOfDays`
				},
				{
					label: "Average Amount",
					component: "text",
					bindTo: `case.facts.bankNotesCarrier${index}AverageAmount`
				},
				{
					label: "Maximum Amount",
					component: "text",
					bindTo: `case.facts.bankNotesCarrier${index}MaxAmount`
				}
			]
		},

		generateSchemaForMessengersB() {
			return [
				{
					label: "Number of messengers and delivery hands",
					component: "text",
					bindTo: "case.facts.bankNotesMessenger"
				},
				{
					label: "Number of days each person per annum",
					component: "text",
					bindTo: "case.facts.bankNotesMessengerNoOfDays"
				},
				{
					label: "Average Amount each",
					component: "text",
					bindTo: "case.facts.bankNotesMessengerAverageAmount"
				},
				{
					label: "Maximum Amount each",
					component: "text",
					bindTo: "case.facts.bankNotesMessengerMaxAmount"
				}
			]
		}
	}
}
</script>
